import { useEffect, useState } from "react";
import { useDragger, getPostionCSSClass } from "../../../helper";

const DraggableNudge = ({
  customizeState,
  nudgeId,
  setNudgePosition,
  id,
  setCustomizeState,
}) => {
  const [userNudge_OfferTextFinal, setUserNudge_OfferTextFinal] = useState("");
  let left = 0;
  let top = 0;
  if (id === "desktop") {
    left = customizeState?.nudge?.desktopNudgePosition?.left;
    top = customizeState?.nudge?.desktopNudgePosition?.top;
  } else {
    top = customizeState?.nudge?.mobileNudgePosition?.top;
  }

  // useDragger(
  //   `nudgeID${nudgeId + id}`,
  //   left,
  //   top,
  //   setNudgePosition,
  //   id,
  //   setCustomizeState
  // );
  const [nudgePosition, setNudgePostion] = useState("justify-right items-right")

  let hour = "00";
  let minute = "00";
  let timer = `${hour}:${minute}:00 hours`;

  let timeInMinute = customizeState?.nudgeOfferText?.minutes
    ? +customizeState?.nudgeOfferText?.minutes
    : 0;

  if (timeInMinute >= 60) {
    // add 0 before single digit
    hour = timeInMinute / 60;
    hour = hour < 10 ? `0${hour}` : hour;
    minute = timeInMinute % 60;
    minute = minute < 10 ? `0${minute}` : minute;
    timer = `${hour}:${minute}:00 hours`;
  } else {
    timeInMinute = timeInMinute < 10 ? `0${timeInMinute}` : timeInMinute;
    timer = `${timeInMinute}:00 minutes`;
  }
  useEffect(() => {
    let userNudge_offerText = customizeState?.nudgeOfferText?.text;
    let userNudge_ExpiryTime = customizeState?.nudgeOfferText?.minutes;
    setUserNudge_OfferTextFinal(
      userNudge_offerText?.replace("{time}", userNudge_ExpiryTime)
    );
  }, [customizeState?.nudgeOfferText]);


  useEffect(() => {
    let nudgePositionVal = customizeState?.nudgePosition?.placement
    // console.log("nudgePositionVal", nudgePositionVal)
    setNudgePostion(nudgePositionVal)
  }, [customizeState?.nudgePosition])
  


  if (customizeState?.useHtmlDesign) {
    return (
      <div
        className={`h-full flex ${getPostionCSSClass(nudgePosition)}`}
      >
        <div
          id={`nudgeID${nudgeId + id}`}
          className="nudge shadow-md select-none"
          style={{
            position: "absolute",
            overflow: "visible",
            marginLeft: `${customizeState?.nudgePosition?.margin_left}px`,
            marginTop: `${customizeState?.nudgePosition?.margin_top}px`,
            marginRight: `${customizeState?.nudgePosition?.margin_right}px`,
            marginBottom: `${customizeState?.nudgePosition?.margin_bottom}px`,
            maxWidth: "100%",
          }}
          dangerouslySetInnerHTML={{ __html: customizeState.htmlDesignCode || '<div style="padding: 20px; color: #888;">Enter HTML code design to preview</div>' }}
        />
      </div>
    );
  }

  return (
    <div
    className={`h-full flex ${getPostionCSSClass(nudgePosition)}`}
  >
    <div
      id={`nudgeID${nudgeId + id}`}
      className="nudge shadow-md p-3 flex justify-center flex-col gap-3 w-[90%] text-center select-none"
      style={{
        backgroundColor: `${customizeState?.nudge?.backgroundColor}`,
        borderWidth: `${customizeState?.nudge?.borderWidth}px`,
        borderColor: `${customizeState?.nudge?.borderColor}`,
        borderStyle: `${customizeState?.nudge?.borderStyle}`,
        borderRadius: `${customizeState?.nudge?.borderRadius}px`,
        position: "absolute",
        marginLeft: `${customizeState?.nudgePosition?.margin_left}px`,
        marginTop: `${customizeState?.nudgePosition?.margin_top}px`,
        marginRight: `${customizeState?.nudgePosition?.margin_right}px`,
        marginBottom: `${customizeState?.nudgePosition?.margin_bottom}px`,
      }}
    >

      <p
        className="text-sm text-gray-800 break-words"
        style={{
          fontStyle: `${customizeState?.nudgeOfferText?.fontStyle}`,
          color: `${customizeState?.nudgeOfferText?.textColor}`,
          backgroundColor: `${customizeState?.nudgeOfferText?.backgroundColor}`,
          borderColor: `${customizeState?.nudgeOfferText?.borderColor}`,
          borderStyle: `${customizeState?.nudgeOfferText?.borderStyle}`,
          borderRadius: `${customizeState?.nudgeOfferText?.borderRadius}px`,
        }}
      >
        <span className="nudgeText">{userNudge_OfferTextFinal}</span>
      </p>
      </div>
      </div>
  );
};

export default DraggableNudge;

  
  
  
  ;
